export default {
  showConfigurator: false,
  initialConfiguration: undefined,
  showLoadingThumbnail: false,
  showLoadingProgress: true,
  // onLoadingProgress: undefined,
  showAR: true,
  showShare: false,
  // locale: undefined,
  allowMobileVerticalOrbit: false,
  // publishStage: undefined,
};
